import type { VideoDockAdapterInput, VideoDockModel } from "@/components/OmniCine/Docks/video/videoDock.types";
import { selectVideoDockIdentity } from "@/components/OmniCine/Docks/video/videoDock.selectors";

export function buildVideoDockModel(input: VideoDockAdapterInput): VideoDockModel {
  const identity = selectVideoDockIdentity(input);

  return {
    title: identity.title,
    subtitle: identity.subtitle,
    kindChip: identity.kindChip,
    sourceChip: identity.sourceChip,
    previewLabel: identity.previewLabel,
    linkedAudioSummary: identity.linkedAudioSummary,
    featureProps: {
      previewStatus: input.previewStatus,
      previewUrl: input.previewUrl ?? identity.resolvedPreviewUrl,
      previewLabel: input.previewLabel || identity.previewLabel,
      err: input.err,
      mediaIsPlaying: input.mediaIsPlaying,
      stageHeight: input.stageHeight,
      previewVideoRef: input.previewVideoRef,
      onGlassPlayPause: input.onGlassPlayPause,
      syncActiveMediaState: input.syncActiveMediaState,
    },
  };
}